import React from 'react';

import { styledDs as styled } from '../../../styles/theme';
import type { DsTheme } from '../../../styles/theme';

export type DsStatusTone = 'good' | 'warning' | 'critical' | 'info' | 'neutral';

export type DsStatusBadgeProps = {
  tone: DsStatusTone;
  children: React.ReactNode;
};

function toneColor(theme: DsTheme, tone: DsStatusTone): string {
  switch (tone) {
    case 'good':
      return theme.colors.statusGood;
    case 'warning':
      return theme.colors.statusWarning;
    case 'critical':
      return theme.colors.statusCritical;
    case 'info':
      return theme.colors.accent;
    default:
      return theme.colors.baseline;
  }
}

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 24px;
  padding: 0 10px;
  border-radius: ${({ theme }) => theme.radius.pill};
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.textSecondary};
  font-family: ${({ theme }) => theme.font.family};
  font-size: ${({ theme }) => theme.font.sizeSm};
  font-weight: ${({ theme }) => theme.weight.medium};
  white-space: nowrap;
`;

const Dot = styled.span<{ $tone: DsStatusTone }>`
  width: 8px;
  height: 8px;
  flex: none;
  border-radius: 50%;
  background: ${({ theme, $tone }) => toneColor(theme, $tone)};
`;

export const DsStatusBadge: React.FC<DsStatusBadgeProps> = ({ tone, children }) => (
  <Badge>
    <Dot $tone={tone} aria-hidden="true" />
    <span>{children}</span>
  </Badge>
);
